export const LEADS_MODAL_STEPS = {
    SETUP: 'setup',
    PREVIEW: 'preview',
    ENRICHING: 'enriching',
    REVIEW: 'review',
};

export const RESULT_BUCKETS = {
    NEW: 'new',
    DUPLICATES: 'duplicates',
};

/** Fixed page size enforced by the nearby_places API (max 20 per request). */
export const PREVIEW_PAGE_SIZE = 20;

export const RADIUS_OPTIONS = [
    { value: '1', label: '1 km' },
    { value: '2', label: '2 km' },
    { value: '5', label: '5 km' },
    { value: '10', label: '10 km' },
];

/** EntityListSelect + NewEntityList / DataGrid key for the leads preview table */
export const LEADS_PREVIEW_ENTITY = {
    entity: 'leadsPreview',
    trueName: 'leadsPreview',
};

/** Column `colId` used for row checkboxes (must match `LeadList` column def) */
export const LEADS_PREVIEW_CHECKBOX_COL_ID = 'lead';
